import ConfirmEmailAliasView from "./ConfirmEmailAliasView";

const config = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
				leftSidePanel: {
					display: false,
				},
				rightSidePanel: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: "/sh-confirm-email-alias",
			component: ConfirmEmailAliasView,
		},
	],
};

export default config;
